// extracted by mini-css-extract-plugin
export default {"notificationIcon":"style_notificationIcon__qNhjP","notificationsMenu":"style_notificationsMenu__DGrEh"};